import { render, staticRenderFns } from "./ParcelPlaceholder.vue?vue&type=template&id=23874011&scoped=true"
import script from "./ParcelPlaceholder.vue?vue&type=script&lang=ts"
export * from "./ParcelPlaceholder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23874011",
  null
  
)

export default component.exports